module.exports = __webpack_public_path__ + "23f2676edc0ac28aa0eca4ac880d6d31.MP3";